import React from "react";
import content from "@/data/content.json";
import { Container } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { footer, meta } = content;

export const Footer = () => (
  <footer data-testid="site-footer" className="has-lines overflow-hidden bg-[#1e2532] pb-12 pt-20 text-white on-dark">
    <FlowLines />
    <Container>
      <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-[1.25fr_1fr_1fr_1fr_1fr] lg:gap-10">
        <div>
          <div className="flex flex-col">
            <span className="flex items-start gap-[2px] leading-none">
              <span className="font-display text-[22px] font-bold leading-none tracking-[-0.03em]">energy</span>
              <span className="font-display text-[22px] font-bold leading-none tracking-[-0.03em] text-[#3ecf9b]">leads</span>
              <span className="mt-[1px] text-[8px] font-bold leading-none text-white/60">TM</span>
            </span>
            <span className="mt-[4px] text-[8.5px] font-semibold uppercase leading-none tracking-[0.13em] text-white/55">
              Mehr Projekte. Mehr Energie.
            </span>
          </div>
          <p className="mt-6 max-w-[360px] text-[15.5px] leading-[1.75] text-white/60">{footer.about}</p>
        </div>
        {footer.columns.map((col) => (
          <nav key={col.title} aria-label={col.title}>
            <p className="text-[12px] font-bold uppercase leading-[1.4] tracking-[0.2em] text-[#3ecf9b]">{col.title}</p>
            <ul className="mt-6 space-y-3.5">
              {col.links.map((l) => (
                <li key={l.label + l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label}`}
                    className="text-[15.5px] text-white/70 hover:text-white"
                    style={{ transition: "color .3s ease" }}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="mt-16 border-t border-white/12 pt-8 text-[14.5px] text-white/55">
        <p data-testid="footer-brandline">
          energyleads<sup className="text-[8px]">TM</sup> — eine Marke der {meta.company} · {meta.street} ·{" "}
          {meta.zip} {meta.city} ·{" "}
          <a href={meta.phoneHref} className="link-underline text-white/80" data-testid="footer-phone">
            {meta.phone}
          </a>
        </p>
        <p className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-[13.5px] text-white/45">
          <span>© {new Date().getFullYear()} Alle Rechte vorbehalten</span>
          <a href="/impressum/" className="text-white/60 hover:text-white">Impressum</a>
          <a href="/datenschutzerklaerung/" className="text-white/60 hover:text-white">Datenschutz</a>
        </p>
      </div>
    </Container>
  </footer>
);
